import api from "./api"

// Helper: normalize backend Appointment (nested slot) to flat shape for calendar
const normalizeAppointment = (apt: any) => {
    if (!apt) return apt;
    // If backend returns nested slot object, flatten it
    if (apt.slot && !apt.slot_start) {
        return {
            ...apt,
            slot_start: apt.slot.start_time,
            slot_end: apt.slot.end_time,
        };
    }
    return apt;
};

// Bookings API
export const appointmentsApi = {
    getAppointments: async (params?: Record<string, any>) => {
        const response = await api.get('/appointments', { params });
        const data = response.data;

        // Normalize each appointment in the response
        if (data.appointments) {
            data.appointments = data.appointments.map(normalizeAppointment);
        }
        return data;
    },

    createAppointment: async (payload: Record<string, any>) => {
        const response = await api.post('/appointments', payload);
        return normalizeAppointment(response.data);
    },

    updateAppointment: async (appointmentId: string, payload: Record<string, any>) => {
        const response = await api.patch(`/appointments/${appointmentId}`, payload);
        return normalizeAppointment(response.data);
    },

    // Fetch the bookable slots for a time window from the backend.
    // params: { smb_id, start_time, end_time } (ISO strings with timezone offset)
    getAvailableSlots: async (params: Record<string, any>, signal?: AbortSignal) => {
        const response = await api.get('/appointments/slots/', { params, signal });
        return (response.data ?? []) as Array<{ start_time: string; end_time: string }>;
    },
};

const bookingApi = {
    getBookingConfig: async (smbId: string) => {
        const response = await api.get(`/smbs/config/booking/${smbId}`)
        return response.data
    },

    getDefaultBookingConfig: async () => {
        const response = await api.get('/smbs/config/default/booking')
        return response.data
    },

    updateBookingConfig: async (smbId: string, payload: Record<string, any>) => {
        const response = await api.patch(`/smbs/config/booking/${smbId}`, payload)
        return response.data
    },
    ...appointmentsApi
}

export default bookingApi;
